{
  "actions": "Actions",
  "add_event_to_google_calendar": "Add event to google calendar",
  "add_guests": "Add guests",
  "calendar": "Calendar",
  "calendar_events": "Calendar events",
  "calendar_settings": "Calendar settings",
  "celebrations": "Celebrations",
  "conference": "Conference",
  "congratulate_colleague": "Congratulate your colleague on their special day!",
  "create_meeting": "Create meeting",
  "create_meeting_for_department": "For {name} department",
  "create_meeting_for_team": "For {name} team",
  "employee_no_email": "{name} has no email in their profile and can't be added to the meeting",
  "employee_no_email_open_profile": "Open profile",
  "enable_calendar": "Enable company calendar",
  "enable_calendar_description": "Enables a shared calendar to view important employee dates such as leave, birthdays, anniversaries, and other milestones, promoting team coordination and awareness",
  "event_all_day": "All day",
  "event_create_title": "Create event",
  "event_delete": "Delete event",
  "event_delete_description": "This event will be deleting from all calendars for all guests",
  "event_edit_title": "Edit event",
  "event_end_time": "End time",
  "event_start_time": "Start time",
  "event_visibility": "Visibility",
  "event_visibility_private": "Private (visible only to you and guests)",
  "event_visibility_public": "Public (visible to everyone)",
  "events": "Events",
  "external_contact": "External contact",
  "get_ready_to_celebrate_colleague_birthday": "Get ready to celebrate your colleague's upcoming birthday!",
  "get_ready_to_celebrate_your_birthday": "Get ready to celebrate your special day!",
  "going_question": "Going?",
  "google_meet": "Google Meet",
  "guest_group_invite": "Invite",
  "guest_group_invite_link": "group of guests",
  "guests": "Guests",
  "happy_birthday": "Happy Birthday to you!",
  "invite": "Invite",
  "join": "Join",
  "kontur_talk": "Kontur Talk",
  "link_will_be_created_after_event_creation": "Link will be available after event creation",
  "no_conference": "No conference",
  "no_title": "No title",
  "notification_settings_calendar_events_caption": "When new event with you is created or changed",
  "organizer": "Organizer",
  "remove_guest": "Remove guest",
  "response_status_accepted": "Accepted",
  "response_status_needs_action": "Invited",
  "response_status_needs_declined": "Declined",
  "response_status_needs_tentative": "Tentative",
  "settings_calendar_description": "Manage company-wide events and time off",
  "show_anniversaries": "Show anniversaries",
  "show_anniversaries_description": "Marks work anniversaries, making it easy to acknowledge employee milestones",
  "show_birthdays": "Show birthdays",
  "show_birthdays_description": "Displays employee birthdays, helping teams stay connected by celebrating personal milestones",
  "show_employee_leaves": "Show employee leaves",
  "show_employee_leaves_description": "If enabled, the calendar will display when employees are on leave (e.g., vacation or sick leave)",
  "show_last_day_of_employees": "Show last day of employees",
  "show_last_day_of_employees_description": "Displays the last day of employees, helping teams prepare for departures and celebrate employee contributions",
  "show_starting_dates_of_new_hires": "Show starting dates of new hires",
  "show_starting_dates_of_new_hires_description": "Shows when new employees are starting, aiding in onboarding visibility",
  "upcoming": "Upcoming",
  "view_calendar": "View calendar",
  "zoom": "Zoom",
  "~": "~",
  "availability_title": "Guest availability",
  "availability_edit_note": "The meeting being edited may also appear as busy time.",
  "availability_groups_title": "Availability excludes guests added by group",
  "availability_groups_note": "Only individually selected employees are checked. Guests added by group are not included.",
  "availability_error": "Could not check calendars. You can still save the meeting.",
  "availability_retry": "Try again",
  "availability_select_for": "Choose a meeting time on the timeline for {name}",
  "availability_busy_time": "Busy: {start}–{end}",
  "availability_suggestions": "Available times · 09:00–20:00",
  "availability_no_slots": "No remaining times fit this meeting duration between 09:00 and 20:00. Choose another day or adjust the duration in the meeting.",
  "availability_day": "Day",
  "availability_add_employees": "Add employees to the guest list to see their availability.",
  "availability_open": "Find a time",
  "availability_guest_conflict": "This guest has another event at the selected time.",
  "availability_close": "Close Find a time",
  "availability_meeting_timezone": "Meeting time zone: {timezone} ({offset})."
}
